import { render, staticRenderFns } from "./EmojiSlider.vue?vue&type=template&id=60b815f4&scoped=true&"
import script from "./EmojiSlider.vue?vue&type=script&lang=js&"
export * from "./EmojiSlider.vue?vue&type=script&lang=js&"
import style1 from "./EmojiSlider.vue?vue&type=style&index=1&id=60b815f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b815f4",
  null
  
)

export default component.exports